import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlideContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
}));

const SlideImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

// Component for image slideshow with automatic rotation
const ImageSlideshow = ({ images, interval = 5000, height = 400 }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: interval,
    fade: true,
    arrows: false,
    beforeChange: (current, next) => setCurrentSlide(next),
    customPaging: (i) => (
      <Box
        sx={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: i === currentSlide ? 'primary.main' : 'rgba(255, 255, 255, 0.5)',
          transition: 'all 0.3s ease',
          cursor: 'pointer',
          margin: '0 4px',
        }}
      />
    ),
  };

  return (
    <SlideContainer sx={{ height }}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <Box key={index} sx={{ height }}>
            <SlideImage src={image} alt={`Slide ${index + 1}`} />
          </Box>
        ))}
      </Slider>
    </SlideContainer>
  );
};

export default ImageSlideshow;
